import { z } from 'zod';

export const ExplanationsPromptOutput = z.object({
  key: z.string(),
  numbers: z.array(z.number()),
  template: z.string(),
  prompt: z.string(),
  llm_role: z.string(),
  mode: z.string(),
});

export type ExplanationsPromptOutput = z.infer<typeof ExplanationsPromptOutput>;

export const ExplanationsPromptsOutput = z.object({
  prompts: z.array(ExplanationsPromptOutput),
});

export type ExplanationsPromptsOutput = z.infer<
  typeof ExplanationsPromptsOutput
>;

export const ExplanationsJudgePrompt = z.object({
  judge_prompt: z.string().nullable(),
  judge_role: z.string().nullable(),
});

export type ExplanationsJudgePrompt = z.infer<typeof ExplanationsJudgePrompt>;

export const ExplanationsAnswerOutput = z
  .object({
    overview: z.string().nullable(),
    description: z.string().nullable(),
    positiveDescription: z.string().nullable(),
    negativeDescription: z.string().nullable(),
  })
  .describe('ExplanationsAnswerOutput');

export type ExplanationsAnswerOutput = z.infer<typeof ExplanationsAnswerOutput>;

export const ExplanationsOutputDictionary = z
  .record(z.string(), ExplanationsAnswerOutput)
  .describe('ExplanationsOutputDictionary');

export type ExplanationsOutputDictionary = z.infer<
  typeof ExplanationsOutputDictionary
>;
